export const getUrlParams=()=>{
   return window.location.pathname;
}